import http from "./httpService";

const apiEndpoint = "/team";

export function getTeam(para) {
  return http.get(apiEndpoint + para);
}
